import React from "react";
import ContentLoader from "react-content-loader";

const RegSkeleton = () => (
  <ContentLoader 
    speed={0.5}
    width={1920}
    height={1080}
    viewBox="0 0 400 160"
    backgroundColor="rgba(0, 0, 0, 0.2)"
    foregroundColor="rgba(0, 0, 0, 0.1)"
  >
    <rect x="100" y="0" rx="5" ry="5" width="200" height="100"/>
  </ContentLoader>
);

export default RegSkeleton;